import { motion } from "framer-motion";
import { EASE } from "@/lib/site";

export const Reveal = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, ease: EASE, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);
